import { useEffect, useRef } from 'react';
import { io, type Socket } from 'socket.io-client';
import { apiBaseUrl } from '../lib/env.js';
import { useSession } from '../state/session.js';
import { IS_DEMO } from '../demo/config.js';
import { createDemoSocket } from '../demo/socket.js';

export function useSocket(): Socket | null {
  const token = useSession((s) => s.accessToken);
  const ref = useRef<Socket | null>(null);

  useEffect(() => {
    if (IS_DEMO) {
      const socket = createDemoSocket();
      ref.current = socket as unknown as Socket;
      return () => {
        socket.disconnect();
        ref.current = null;
      };
    }
    if (!token) {
      ref.current?.disconnect();
      ref.current = null;
      return;
    }
    const socket = io(apiBaseUrl, {
      transports: ['websocket', 'polling'],
      auth: { token },
      reconnection: true,
    });
    ref.current = socket;
    return () => {
      socket.disconnect();
      ref.current = null;
    };
  }, [token]);

  return ref.current;
}
